import {createAsyncThunk} from '@reduxjs/toolkit'

import {LockMethod, LockMethodType} from '@web/core/constants'
import {isNaverApp, isPayApp} from '@web/helpers/userAgent'

type DeviceInfoType = {
    detail: {
        deviceSecure: 'biometrics' | 'password' | 'insecure'
    }
}

type ThunkApi<RejectValue = unknown> = {
    rejectValue: RejectValue
}

const getLockMethod = (lockMethod: DeviceInfoType['detail']['deviceSecure']) => {
    if (lockMethod === 'biometrics') {
        return LockMethod.BIOMETRICS
    } else if (lockMethod === 'password') {
        return LockMethod.PASSWORD
    }

    return LockMethod.INSECURE
}

/**
 * 휴대폰 잠금 방식LockMethod
 */
export const getDeviceLockMethod = createAsyncThunk<LockMethodType, void, ThunkApi>('getLockMethod', async () => {
    const payload: LockMethodType = await new Promise((resolve) => {
        if (isNaverApp || isPayApp) {
            /**
             * @function naverappapi.getDeviceInfo
             * @description 모바일 네이버페이 웹 -> 네이버 앱으로 디바이스 정보를 요청
             */
            if (window['naverappapi'] && window['naverappapi'].getDeviceInfo) {
                window['naverappapi'].getDeviceInfo('{"name":"deviceSecure"}')
                /**
                 * @function window.addEventListener('deviceInfo',f)
                 * @description deviceInfo 이벤트를 리스닝하고 있다가 네앱에서 해당 이벤트를 호출해주면 디바이스 잠금 정보를 세팅합니다.
                 */
                /* eslint-disable @typescript-eslint/no-explicit-any */
                window.addEventListener('deviceInfo', (e: DeviceInfoType | any) => {
                    resolve(getLockMethod(e.detail.deviceSecure))
                })
            } else {
                resolve(LockMethod.INSECURE)
            }
        } else {
            resolve(LockMethod.INSECURE)
        }
    })

    return payload
})
